import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { prepareCustomer } from './utility/prepare';
import useTokenManager from '../livekinnect-client/hooks/useTokenManager';

export const CustomerContext = React.createContext(undefined);
CustomerContext.displayName = 'CustomerContext';

const storageKeyPrefix = 'live-kinnect';
const CustomerProvider = ({ customer, children }) => {
	const { Provider } = CustomerContext;
	const customerRef = useRef(prepareCustomer(customer));
	const tokenManager = useTokenManager(`${storageKeyPrefix}-${customerRef.current.csrf}`);

	useEffect(() => {
		// remove preexisting localStorage items not belonging to this csrf token
		Object.keys(window.localStorage)
			.filter(key => key !== `${storageKeyPrefix}-${customerRef.current.csrf}` && key.startsWith(storageKeyPrefix))
			.forEach(key => window.localStorage.removeItem(key));
	}, [customerRef]);

	return (
		<Provider
			value={{
				customer: customerRef.current,
				tokenManager
			}}>
			{children}
		</Provider>
	);
};

CustomerProvider.propTypes = {
	customer: PropTypes.object,
	children: PropTypes.any
};

export default CustomerProvider;

export const withCustomer = Component => {
	const CustomerComponent = ({ customer, ...props }) => {
		return (
			<CustomerProvider customer={customer}>
				<Component {...props} />
			</CustomerProvider>
		);
	};

	CustomerComponent.propTypes = {
		customer: PropTypes.object
	};

	return CustomerComponent;
};
